import {gql} from 'apollo-angular';

export const ROOKIE_SCHOLAR_BOOKING = gql`
  mutation RookieScholarBooking(
    $districtId: Int!,
    $positionId: Int!,
    $schoolId: Int!,
    $classId: Int!,
    $selectedTimeSlots: [Int!]!,
    $firstName: String!,
    $lastName: String!,
    $email: String!,
    $phoneNumber: String!,
    $address: String!,
    $zip: String!,
    $location: String!,
    $privacyBoxSelected: Boolean!

  ) {
    rookieScholarBooking(
      scholarData: {
        districtId: $districtId,
        positionId: $positionId,
        schoolId: $schoolId,
        classId: $classId,
        selectedTimeSlots: $selectedTimeSlots,
        firstName: $firstName,
        lastName: $lastName,
        email: $email,
        phoneNumber: $phoneNumber,
        address: $address,
        zip: $zip,
        location: $location,
        privacyBoxSelected: $privacyBoxSelected
      }
    ) {
      type,
      message,
      code
    }
  }

`;
